import { Injectable } from '@angular/core';

interface EventoFila {
  readonly nome: string;
  readonly contexto: Record<string, unknown>;
  readonly enqueuedAt: number;
}

@Injectable({ providedIn: 'root' })
export class EventQueueService {
  private queue: EventoFila[] = [];
  private readonly TIMEOUT_MS = 30000;

  enqueue(nome: string, contexto: Record<string, unknown>): void {
    this.queue.push({ nome, contexto, enqueuedAt: Date.now() });
  }

  drainByName(nome: string): { nome: string; contexto: Record<string, unknown> }[] {
    const agora = Date.now();
    const resultado: { nome: string; contexto: Record<string, unknown> }[] = [];
    this.queue = this.queue.filter((item) => {
      if (item.nome !== nome) return true;
      if (agora - item.enqueuedAt > this.TIMEOUT_MS) return false; // descarta expirado
      resultado.push({ nome: item.nome, contexto: item.contexto });
      return false;
    });
    return resultado;
  }
}
